import { getSafeBNVariables } from './getSafeBNVariables';
import React from 'react';
import { i18n } from './i18nInstance';

export type TFunction = (
  key: string,
  variables?: object,
  withHTML?: boolean,
) => string;

export const t: TFunction = (key, variables, withHTML) => {
  const translated = i18n.t(key, {
    ...getSafeBNVariables(variables),
    ns: 'translation',
    nsSeparator: ':::',
    interpolation: { escapeValue: !withHTML, alwaysFormat: true },
  });

  if (withHTML) {
    return (
      <span dangerouslySetInnerHTML={{ __html: translated }} />
    ) as unknown as string;
  }

  return translated as unknown as string;
};

export const tHTML: TFunction = (key, variables) => {
  return t(key, variables, true);
};
